
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/common/Logo";
import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface AuthHeaderProps {
  mode: "signin" | "signup" | "forgotPassword" | "resetPassword";
}

export function AuthHeader({ mode }: AuthHeaderProps) {
  const navigate = useNavigate();
  
  return (
    <div className="mb-6 flex flex-col items-center">
      <Button 
        variant="ghost" 
        size="sm" 
        className="mb-4 self-start" 
        onClick={() => navigate("/")}
      >
        <ChevronLeft className="mr-1 h-4 w-4" />
        Back to Home
      </Button>
      
      <Logo size="medium" className="mb-6" />
      
      {mode === "forgotPassword" ? (
        <h1 className="text-2xl font-bold text-center">Reset your password</h1>
      ) : mode === "resetPassword" ? (
        <h1 className="text-2xl font-bold text-center">Set new password</h1>
      ) : (
        <h1 className="text-2xl font-bold text-center">
          {mode === "signup" ? "Create your account" : "Welcome back"}
        </h1>
      )}
    </div>
  );
}
